import { getCookies } from './Cookies'
import { decryptCrypto } from './Encryption'

const getAccount = () => {
  if (getCookies('_wsso')) {
    return decryptCrypto(getCookies('_wsso'))
  }
  return null
}

const getSeller = () => {
  if (getCookies('_wssc')) {
    return decryptCrypto(getCookies('_wssc'))
  }
  return null
}

export { getAccount, getSeller }
